import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getAllQuotes: ApiMethod<
  string,
  Server.QuoteOutput[],
  any
> = async (contentId, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Quote_Client(undefined, contentClient);
    const response = await client.quote_get_V1(undefined, contentId);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewQuote: ApiMethod<
  Server.CreateQuoteInput,
  string,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Quote_Client(undefined, contentClient);
    const response = await client.quote_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const editQuote: ApiMethod<Server.EditQuoteInput, string, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Quote_Client(undefined, contentClient);
    const response = await client.quote_put_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deleteQuote: ApiMethod<string, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Quote_Client(undefined, contentClient);
    const response = await client.quote_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
